/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Will_Be_Activa_UntilInputs */



/**
* | output |
* | --- |
* | "Will be active until {date}" |
*
* @param {Will_Be_Activa_UntilInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const will_be_activa_until = /** @type {((inputs: Will_Be_Activa_UntilInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Will_Be_Activa_UntilInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Will be active until ${i?.date}`)
	return /** @type {LocalizedString} */ (`Sera activée jusqu'au ${i?.date}`)
});